import { decodeReplayV2 } from './decoder';
import { REPLAY_SCHEMA_VERSION, type FreeSpinReplayV2, type ReplayDraftV2, type ReplayStepV2 } from './schema';

export function createReplayDraft(input: Omit<ReplayDraftV2, 'version' | 'steps' | 'retriggerCount'>): ReplayDraftV2 {
  return Object.freeze({ ...input, version: REPLAY_SCHEMA_VERSION, retriggerCount: 0, steps: Object.freeze([]) });
}

export function appendReplayStep(draft: ReplayDraftV2, step: ReplayStepV2): ReplayDraftV2 {
  if (step.spinIndex !== draft.steps.length + 1) throw new RangeError('Replay steps must be appended in sequence.');
  return Object.freeze({
    ...draft,
    totalAwarded: Math.max(draft.totalAwarded, step.freeSpinsTotalAfter),
    retriggerCount: draft.retriggerCount + (step.retriggerAwarded > 0 ? 1 : 0),
    steps: Object.freeze([...draft.steps, Object.freeze(step)]),
  });
}

export function completeReplay(
  draft: ReplayDraftV2,
  input: Readonly<{ clientEntryId: string; ownerUid?: string; createdAt: number }>,
): FreeSpinReplayV2 {
  if (draft.steps.length === 0) throw new RangeError('A completed replay needs at least one step.');
  const last = draft.steps.at(-1)!;
  const candidate: FreeSpinReplayV2 = {
    version: 2,
    id: input.clientEntryId,
    clientEntryId: input.clientEntryId,
    ...(input.ownerUid ? { ownerUid: input.ownerUid } : {}),
    name: draft.name,
    betCents: draft.betCents,
    totalWinCents: last.cumulativeWinCents,
    createdAt: input.createdAt,
    presentationMode: draft.presentationMode,
    totalSpins: draft.steps.length,
    totalAwarded: draft.totalAwarded,
    retriggerCount: draft.retriggerCount,
    finalStickyCount: last.stickyAfter.length,
    steps: draft.steps,
    linesComplete: true,
  };
  const decoded = decodeReplayV2(candidate);
  if (!decoded) throw new TypeError('Completed replay failed schema validation.');
  return Object.freeze(decoded);
}
